import { post } from '../mocks/postsMocks/postsStore';
import UI from '../ui';

// quick mock images database for the demo
export const images_db: Record<string, File> = {};

export const getPostImageUrls: (post: post) => string[] = (post) => {
  const { id, images } = post;
  const isStatic = id <= 36;
  return images.map(image => isStatic ? `/hotels/${image}` : URL.createObjectURL(images_db[image]));
}

const PostImage: React.FC<{ post: post }> = ({ post }) => {
  const { id, images } = post;
  return (
    <UI.Carousel>
      {images.map((image, i) => {
        const isStatic = id <= 36;
        return (
          <img
            key={i}
            src={isStatic ? `/hotels/${image}` : URL.createObjectURL(images_db[image])}
            style={{
              borderRadius: '5px',
              maxHeight: '300px',
              objectFit: 'cover',
            }}
          />
        );
      })}
    </UI.Carousel>
  );
};

export default PostImage;
